import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool, utils_tool } from '../../../tool'
let { WizContainer, WizReduxTemplate } = framework_tool;
let { checkStrLength } = utils_tool;
class OrgNodeCategory extends WizContainer {

  componentName = 'OrgNodeCategory';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleTreeData(nextProps, nextState, key) {
    let o = nextProps[key]
    let len = 20
    if (o['success']) {
      let f = (v) => {
        v && v.forEach(val => {
          val['title'] = checkStrLength(val['title'], len);
          if (val['children'] && val['children'].length > 0) {
            f(val['children'])
          }
        });
      }
      f(o['data'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig,
      apiDataFormat: {
        add: this._handleCMD,
        update: this._handleCMD,
        delete: this._handleCMD,
        enable: this._handleCMD,
        treeData: this._handleTreeData,
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(OrgNodeCategory);
